export const normalizeValue = (value) => (value === null || value === undefined ? '' : String(value).trim());

export const buildWarningMessage = (result) => {
  if (!result) return '';
  const warnings = [];
  if (Array.isArray(result.warnings)) warnings.push(...result.warnings);
  if (Array.isArray(result.email?.warnings)) warnings.push(...result.email.warnings);
  if (result.email && result.email.ok === false) warnings.push('Email send failed.');
  return warnings.filter(Boolean).join(' ');
};

export const resolveErrorMessage = (error) => {
  const data = error?.response?.data;
  if (Array.isArray(data?.errors) && data.errors.length) {
    return data.errors.map((item) => item.message).filter(Boolean).join(' ');
  }
  if (data?.reason) {
    return String(data.reason)
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }
  return data?.message || error?.message || 'Something went wrong.';
};

export const buildUpdatePayload = (row, values) => {
  if (!row || !values) return null;
  const payload = { id: row.id };

  if (normalizeValue(values.accountName) !== normalizeValue(row.accountName)) {
    payload.accountName = normalizeValue(values.accountName);
  }
  if (normalizeValue(values.buySellAccountId) !== normalizeValue(row.buySellAccountId)) {
    payload.buySellAccountId = normalizeValue(values.buySellAccountId);
  }
  if (normalizeValue(values.bac) !== normalizeValue(row.bac)) {
    payload.bac = normalizeValue(values.bac);
  }
  if (normalizeValue(values.purchasingBAC) !== normalizeValue(row.purchasingBAC)) {
    payload.purchasingBAC = normalizeValue(values.purchasingBAC);
  }
  if (values.buySellStage && values.buySellStage !== row.buySellStage) {
    payload.buySellStage = values.buySellStage;
  }
  if (values.stageDate && values.stageDate !== row.stageDate) {
    payload.stageDate = values.stageDate;
  }
  if (normalizeValue(values.notes) !== normalizeValue(row.notes)) {
    payload.notes = normalizeValue(values.notes);
  }
  if (values.dafFile) {
    payload.dafFile = values.dafFile;
  }

  return payload;
};
